
// DEPRECATED: This file is maintained for backwards compatibility
// Please use useSessionCheck from src/auth/hooks/useSessionCheck instead

import { useSessionCheck } from '@/auth/hooks/useSessionCheck';

// Re-export the hook to maintain backwards compatibility
export const useSessionChecks = useSessionCheck;
